export const errorClassNames =
    "flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 absolute -bottom-4 whitespace-nowrap z-10"

export const defaultInputClassNames =
    "placeholder:text-text-blue/50 py-2.5 px-4 text-base sm:text-sm block rounded-md border border-border-blue text-text-blue transition-colors focus:ring-0 focus:outline-none focus:border-text-blue focus-within:border-text-blue w-full h-fit !bg-transparent "

export const defaultLabelClassNames = "flex items-center gap-2 text-dark-blue mb-3 whitespace-nowrap"

export const inlineLabelClasses = "flex items-center gap-2 text-dark-blue whitespace-nowrap"
